import { FaStar, FaCheckCircle } from "react-icons/fa";
import GoogleGIcon from "./GoogleGIcon";

const GoogleReviewCard = ({ data }) => {
  if (!data) return null;
  const rating = typeof data.rating === "number" ? data.rating : 5;
  const stars = Array.from({ length: 5 }, (_, i) => i < rating);

  return (
   <div className="ltn__testimonial-item ltn__testimonial-item-google">
      <header className="ltn__google-badge">
        <GoogleGIcon />
        <span>Posted on Google</span>
        <span
          className="ltn__google-stars"
          role="img"
          aria-label={`Rated ${rating} out of 5`}
        >
          {stars.map((filled, i) => (
            <FaStar key={i} aria-hidden="true" />
          ))}
        </span>
      </header>

      <p className="ltn__google-quote">{data.description}</p>

      <footer className="ltn__google-author">
        <div className="ltn__google-meta">
          <strong>{data.name}</strong>
          <span>{data.type}</span>
        </div>
        <FaCheckCircle
          className="ltn__google-verified"
          aria-label="Verified reviewer"
        />
      </footer>
    </div>
  );
};

export default GoogleReviewCard;
